var React = require('react');

function Number3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.96961 23.745C8.65461 24.465 8.47461 25.545 8.47461 26.4C8.47461 31.215 12.4346 35.76 19.4996 35.76C25.7546 35.76 30.5696 31.935 30.5696 25.725C30.5696 21.405 27.7346 18.885 24.1796 17.805C27.1946 16.725 29.0396 13.8 29.0396 10.695C29.0396 6.33 25.6196 3 19.2296 3C13.2896 3 9.46461 6.87 9.46461 11.37C9.46461 12.135 9.59961 12.9 9.86961 13.665L14.2796 12.81C14.1446 12.405 14.0546 12 14.0546 11.505C14.0546 8.76 16.3946 7.05 19.1846 7.05C22.2446 7.05 24.3596 8.625 24.3596 11.28C24.3596 14.115 22.2896 16.41 17.2496 16.41V20.1C22.0196 20.1 25.7096 21.675 25.7096 25.815C25.7096 29.55 23.2796 31.53 19.4996 31.53C16.0346 31.53 13.3346 29.28 13.3346 26.265C13.3346 25.59 13.3796 25.23 13.5146 24.825L8.96961 23.745Z"}));
}

Number3.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38"};

module.exports = Number3;

Number3.default = Number3;
